






























































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import moment from 'moment';
import SuggestModule from '@/store/modules/Suggest';
import AuthModule from '@/store/modules/Auth';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Table from '@/components/Table/Index.vue';
import SuggestBody from '@/components/Table/SuggestBody.vue';
import SuggestData from '@/data/SuggestData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import XLSX from 'xlsx';

@Component({
  components: {
    Table,
    SuggestBody,
    Breadcrumb,
  },
})
export default class WinLoseMemberView extends Mixins(ToolMixin, ErrorHandleMixin) {
  SuggestInstance = getModule(SuggestModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  TopicList = [
    {
      name: 'TOTAL',
      value: 'TOTAL',
    },
  ];

  selectionTopic = 'TOTAL';

  Criteria = {
    ...this.Period,
    userId: this.AuthInstance.user._id,
  };

  BreadcrumbList = [
    {
      username: this.AuthInstance.user.username,
      userId: this.AuthInstance.user._id,
    },
  ];

  SuggestList = [];

  LoginName = '';

  TableHead = SuggestData.TableHeadMEMBER;

  Type = '';

  startDate = '';

  endDate = '';

  momentFormat = {
    stringify: (date: string): string => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value: string): string => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  created() {
    this.initial();
    this.fetchTopic();
    this.fetchSuggest();
  }

  async LoadSheet() {
    const criteria = { ...this.Criteria, ...this.Period };
    this.GeneralInstance.toggleLoading(true);
    const data = await this.SuggestInstance.DownloadSheet(criteria);
    this.GeneralInstance.toggleLoading(false);
    const dataWS = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, dataWS, 'Suggestion');
    XLSX.writeFile(wb, 'Suggestion.xlsx');
  }

  initial() {
    this.Criteria = {
      ...this.Period,
      userId: this.AuthInstance.user._id,
    };
    this.LoginName = '';
  }

  async fetchSuggest() {
    const criteria = { ...this.Criteria, ...this.Period };
    this.GeneralInstance.toggleLoading(true);
    const res = await this.SuggestInstance.FetchSuggest(criteria);
    if (res.code) {
      this.checkError(res);
    } else {
      this.topicFilter();
    }
    this.GeneralInstance.toggleLoading(false);
  }

  topicFilter() {
    this.SuggestList = this.selectionTopic === 'TOTAL'
      ? [...this.SuggestInstance.suggestMember]
      : this.SuggestInstance.suggestMember
        .filter((s: any) => s.topic === this.selectionTopic);
  }

  async fetchTopic() {
    const topics = await this.SuggestInstance.FecthTopic();
    this.TopicList = [
      ...this.TopicList,
      ...topics.map((topic) => ({ name: topic.name.en, value: topic.name.en })),
    ];
  }

  handleBreadcrumb({ userId }) {
    const index = this.BreadcrumbList.findIndex((item) => item.userId === userId);
    const idx = index > 0 ? index + 1 : 1;
    this.BreadcrumbList.splice(idx, 99);
    this.Criteria.userId = userId;
    this.fetchSuggest();
  }

  handleSub({ _id, username }) {
    this.Criteria.userId = _id;
    this.BreadcrumbList.push({
      username,
      userId: _id,
    });
    this.fetchSuggest();
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchSuggest();
  }

  onSubmit() {
    this.fetchSuggest();
  }

  onReset() {
    this.initial();
    this.fetchSuggest();
  }
}
